import { Divider as DividerAntd } from 'antd';
import styled from 'styled-components';

export const Drafts = styled.div`
  margin-bottom: 50px;
  font-weight: bold;
`;

export const Divider = styled(DividerAntd)`
  margin: 5px 0;
`;
